// File: src/hooks/useCreditBubbleAnimation.js
import React, { useRef, useState } from "react";
import CreditStreamAnimation from "../components/trends/CreditStreamAnimation";
import { AnimatePresence } from "framer-motion";

const useCreditBubbleAnimation = () => {
  const [showCredits, setShowCredits] = useState(false);
  const [isTargetHitting, setIsTargetHitting] = useState(false);
  const [origin, setOrigin] = useState(null);
  const [target, setTarget] = useState(null);
  const [activeRating, setActiveRating] = useState(null);

  const originRef = useRef(null);
  const targetRef = useRef(null);
  const isAnimatingRef = useRef(false);

  // 🌟 Trigger function now accepts pointsToAward to pass to the arrival event
  const trigger = (ratingType, pointsToAward = 3) => {
    if (isAnimatingRef.current) return;

    if (originRef.current && targetRef.current) {
      const originRect = originRef.current.getBoundingClientRect();
      const targetRect = targetRef.current.getBoundingClientRect();

      setOrigin({
        x: originRect.left + originRect.width / 2,
        y: originRect.top + originRect.height / 2,
      });

      setTarget({
        x: targetRect.left + targetRect.width / 2,
        y: targetRect.top + targetRect.height / 2,
      });

      setActiveRating(ratingType);
      isAnimatingRef.current = true;
      setShowCredits(true);

      // ⏱️ TIMING STEP 1: Bubbles hit the target (~1100ms into flight)
      setTimeout(() => {
        setIsTargetHitting(true);

        // ⚡ 2. DISPATCH TOP MENU BAR ANIMATION EVENT EXACTLY UPON BUBBLE ARRIVAL
        window.dispatchEvent(
          new CustomEvent("optimistic_points_earned", {
            detail: { points: pointsToAward },
          })
        );
      }, 1100);

      // ⏱️ TIMING STEP 2: Hide credit bubble stream overlay
      setTimeout(() => {
        setShowCredits(false);
        setIsTargetHitting(false);
      }, 2100);

      // ⏱️ TIMING STEP 3: Unlock animation guard
      setTimeout(() => {
        isAnimatingRef.current = false;
      }, 2500);
    }
  };

  const CreditAnimationOverlay = (
    <AnimatePresence mode="wait">
      {showCredits && origin && target && (
        <CreditStreamAnimation
          key="credit-bubble-overlay-single"
          origin={origin}
          target={target}
          rating={activeRating}
        />
      )}
    </AnimatePresence>
  );

  return {
    trigger,
    originRef,
    targetRef,
    isTargetHitting,
    CreditAnimationOverlay,
  };
};

export default useCreditBubbleAnimation;